import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Row, Col, Stepper } from '@gympass/yoga'
import Container from '@components/Container'

import * as Style from './Launching.style'

export default function Launching() {
  const intl = useIntl()
  return (
    <Style.LaunchingWrapper>
      <Container>
        <Row>
          <Col xxs={12} md={9}>
            <Style.Title>
              <FormattedMessage id="smb_acquisition_commercial_offer.benefit_availability_timeline.title" />
            </Style.Title>
          </Col>

          <Col xxs={12} md={3}>
            <Style.SubtitleWrapper>
              <Style.Subtitle>
                <FormattedMessage
                  id="smb_acquisition_commercial_offer.benefit_availability_timeline.estimate"
                  values={{
                    days: <strong>{7}</strong>,
                  }}
                />
              </Style.Subtitle>
            </Style.SubtitleWrapper>
          </Col>
        </Row>

        <Row>
          <Col xxs={12}>
            <Style.StepperCard>
              <Style.StepperWrapper>
                <Stepper activeStep={1}>
                  <Style.Step
                    label={
                      intl.messages[
                        'smb_acquisition_commercial_offer.benefit_availability_timeline.steps.step_1'
                      ]
                    }
                  />

                  <Style.Step
                    label={
                      intl.messages[
                        'smb_acquisition_commercial_offer.benefit_availability_timeline.steps.step_2'
                      ]
                    }
                  />

                  <Style.Step
                    label={
                      intl.messages[
                        'smb_acquisition_commercial_offer.benefit_availability_timeline.steps.step_3'
                      ]
                    }
                  />

                  <Style.Step
                    label={
                      intl.messages[
                        'smb_acquisition_commercial_offer.benefit_availability_timeline.steps.step_4'
                      ]
                    }
                  />

                  <Style.Step
                    label={
                      intl.messages[
                        'smb_acquisition_commercial_offer.benefit_availability_timeline.steps.step_5'
                      ]
                    }
                  />

                  <Style.Step
                    label={
                      intl.messages[
                        'smb_acquisition_commercial_offer.benefit_availability_timeline.steps.step_6'
                      ]
                    }
                  />
                </Stepper>
              </Style.StepperWrapper>
            </Style.StepperCard>
          </Col>
        </Row>
      </Container>
    </Style.LaunchingWrapper>
  )
}
